// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from './../../../constants/Colors'

export default makeStyles({
  icon: {
    color: Colors.PRIMARY_FONT_COLOR,
    marginLeft: 5,
    marginRight: 5,
  },
  root: {
    width: '114px',
  },
  select: {
    border: `solid 1px ${Colors.DISABLED_COLOR}`,
    color: Colors.PRIMARY_FONT_COLOR,
    fontSize: 15,
    padding: '14px 25px 14px 10px',
  },
})
